import React, { useState, useEffect } from "react";
import { FaCalendarCheck, FaComments, FaPhone } from "react-icons/fa";
import "./FloatingScrollCTA.css";

export default function FloatingScrollCTA({ onBook, onTalk }) {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      if (window.scrollY > 200) setVisible(true);
      else setVisible(false);
    };
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  return (
    <div className={`floating-scroll-cta ${visible ? "visible" : ""}`}>
      {/* <button className="btn cta-book" onClick={onBook} aria-label="Book Appointment">
        <FaCalendarCheck className="icon" />
        <span>Book Appointment</span>
      </button> */}
      <button className="btn cta-talk" onClick={onTalk} aria-label="Talk With Us">
        <FaPhone  className="icon" />
        <span>Talk With Us</span>
      </button>
    </div>
  );
}
